// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__Dywsx","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__13pgq"};